import React, { useState } from 'react'
import SideBarMenu from './sideBar/sideBarMenu'
import { Box, Container, Drawer, Stack, Typography, useMediaQuery } from '@mui/material'
import mainLogo from '../images/logo_black_letters_2.png';
import MenuIcon from '@mui/icons-material/Menu';
import AimdLinearBar from './progressBars/aimdLinearBar';
import { useTheme } from '@emotion/react';

function AimdFlowQuestionBase( { IsShowBackIcon, isShowMenuIcon, children, backButtonHandler, aimdLinearBarValue, isShowStepper = true, isBottomLogoVisible = true } ) {
    const isSmallHeight = useMediaQuery( '(max-height:700px)' );
    const [ open, setOpen ] = useState( false );
    const theme = useTheme();
    const isLaptop = useMediaQuery( theme.breakpoints.up( 'lg' ) );
    return (
        <Box sx={ {
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            minHeight: {
                xs: '88vh', // Adjust height for mobile devices to account for the footer, making it responsive
                sm: '98vh',
                md: '100vh',
                lg: '100vh'

            }, // Full viewport height

            position: "relative",
            boxSizing: "border-box",
            padding: {
                xs: '10px', // Adjust height for mobile devices to account for the footer, making it responsive
                sm: '10px 20px',
                md: '20px 40px',
                lg: '20px 50px'
            },
            fontFamily: "Poppins",
            width: "100%",

        } } >
            {/* header part started */ }
            <Box sx={ {
                display: 'flex',
                flexDirection: "column",
                flexGrow: 0,

            } }>
                <Box sx={ {
                    textAlign: "end",
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between"
                } }>
                    { IsShowBackIcon && <Box sx={ { display: "flex", alignItems: "center", cursor: "pointer", } } onClick={ backButtonHandler }>
                        <img src='/others/back.svg' alt="back-icon" style={ { width: "20px" } } />
                        <Typography
                            color="#72D8DA"
                            variant="p"
                            component="p"
                            fontWeight="600"
                            fontSize="14px"
                            paddingLeft="5px"
                        >
                            Back
                        </Typography>

                    </Box>

                    }
                    <Box sx={ {
                        display: "flex", justifyContent: "right", width: "100%", alignItems: "center"
                    } }>
                        { isShowMenuIcon && <MenuIcon onClick={ () => setOpen( true ) } fontSize='large'
                            sx={ { cursor: "pointer", } } /> }
                    </Box>
                </Box>

                { isShowStepper && <Box>
                    <AimdLinearBar value={ aimdLinearBarValue } barHeight={ isLaptop ? "16px" : "10px" } />
                </Box>

                }
                {/* Hedaer ends */ }
            </Box>
            {/* main question contaier started */ }
            <Stack
                sx={ {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    flexGrow: {
                        lg: 0.5,
                        md: 0.5,
                        sm: 0.5,
                        xs: isSmallHeight ? 0.3 : 0.5
                    },
                    //  height: "70%",
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "10px",
                    overflowY: "scroll",
                    paddingBottom: isBottomLogoVisible ? "100px" : "0px"
                } }>

                { children }

            </Stack>

            {/* footer logo starts */ }
            {
                isBottomLogoVisible &&
                <Stack style={ {
                    position: "absolute",
                    bottom: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "white",
                    width: "100%",
                    right: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                } }>
                    <img
                        src={ mainLogo }
                        alt="AIMD logo"

                        style={ {
                            width: isLaptop ? "100px" : "70px",

                            paddingBottom: isLaptop ? "20px" : "10px",
                            height: "auto",
                            userSelect: "none",
                        } }
                    />
                </Stack>
            }


            <Drawer anchor="right" open={ open } onClose={ () => setOpen( false ) }>
                <SideBarMenu setIsMenuOpen={ setOpen } />
            </Drawer>
        </Box >
    )
}

export default AimdFlowQuestionBase